package org.moxultimate.topwithmox.components.crud

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.moxultimate.topwithmox.components.buttons.PressableButtonStyle
import org.moxultimate.topwithmox.theme.FontFamily

/**
 * Inline success or error banner for CRUD forms.
 *
 * @param message  Text to display.
 * @param isError  Red styling when true; green when false.
 * @param onDismiss Called when the user clicks the ✕ dismiss button.
 */
@Composable
fun CRUDStatusBanner(message: String, isError: Boolean, onDismiss: () -> Unit) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(leftRight = 20.px, topBottom = 14.px)
            .borderRadius(12.px)
            .backgroundColor(if (isError) Colors.MistyRose else Colors.HoneyDew)
            .border(1.px, LineStyle.Solid, if (isError) Colors.LightCoral else Colors.MediumSeaGreen),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically,
    ) {
        SpanText(
            text = message,
            modifier = Modifier
                .fontFamily(FontFamily)
                .fontSize(14.px)
                .color(if (isError) Colors.Crimson else Colors.DarkGreen),
        )
        SpanText(
            text = "✕",
            modifier = PressableButtonStyle.toModifier()
                .fontFamily(FontFamily)
                .fontSize(14.px)
                .color(Colors.Gray)
                .onClick { onDismiss() },
        )
    }
}
